/* eslint-disable react/prop-types */
import { Box } from "@mui/material";
import React, { useState } from "react";
// import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import * as Sentry from "@sentry/react";
import Appointment from "../../../services/api/appointment";
import Button from "../../common/Button";
import Modal from "../../common/Modal/Modal";
import InputField from "../../common/new/InputField/InputField";
import Typography from "../../common/new/Typography/Typography";
import styles from "./AppointmentCancelRequestModal.styles";
import { debounce } from "../../../utils/helper";
import { CommonStyles } from "../../common/Button/commonButtonStyle";
import { AlertStatus } from "../../../contants";

function Alert({ open, onClose, onSubmit }) {
  return (
    <Box>
      <Modal open={open} onClose={onClose}>
        <Typography
          style={{ fontSize: "20px", fontWeight: "500", paddingBottom: "20px" }}
        >
          Are you sure you want to
          <br />
          cancel this application ?
        </Typography>
        <Box style={{ paddingTop: "50px", justifyContent: "space-between" }}>
          <Button
            onClick={onSubmit}
            label="Yes"
            style={{ marginRight: "10px" }}
          />
          <Button onClick={onClose} label="No" variant="outlined" />
        </Box>
      </Modal>
    </Box>
  );
}

function AppointmentCancelRequestModal({
  application,
  open,
  onClose,
  toast,
  refreshList,
}) {
  const [remark, setRemark] = useState("");
  const [openAlert, setOpenAlert] = useState(false);

  const toggleAlert = () => {
    setOpenAlert(false);
  };

  const acceptAppointmentHandler = () => {
    setOpenAlert(true);
  };

  const submitCancelRequest = async () => {
    try {
      const body = {
        data: {
          message: remark,
        },
      };
      await Appointment.AppointmentCancelRequest(
        body,
        application.memberDetails.memberId,
        application.id
      );
      toast.show("Cancel Requested Successfully", AlertStatus.SUCCESS);
      setTimeout(() => {
        setRemark("");
        onClose();
        refreshList();
      }, 2000);
    } catch (error) {
      toast.show(error.message, AlertStatus.ERROR);
      Sentry.captureException(error);
    }
  };

  const handleModalClose = () => {
    setRemark("");
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box>
        <Typography variant="title2" color="#8c8c8c">
          Appointment Cancellation Request
        </Typography>
        <Box mt={7}>
          {" "}
          <InputField
            type="text"
            defaultValue=""
            key="remark"
            name="remark"
            label="Enter your remark here..."
            style={styles.inputStyle}
            value={remark}
            onChange={(e) => setRemark(e.target.value)}
            InputProps={{ sx: { minHeight: "91px" } }}
          />
        </Box>
      </Box>
      <Box display="flex" gap={6} mt={4}>
        <Button
          type="submit"
          onClick={() => {
            if (!remark) {
              toast.show("Remarks should not be empty!", AlertStatus.ERROR);
            } else {
              acceptAppointmentHandler();
            }
          }}
          style={{ ...CommonStyles.buttonStyle, width: "60%" }}
          label="REQUEST CANCELLATION"
        />
        <Button
          variant="outlined"
          style={{
            ...CommonStyles.buttonStyle,
          }}
          onClick={handleModalClose}
          label="CANCEL"
        />
      </Box>
      <Alert
        open={openAlert}
        onClose={toggleAlert}
        onSubmit={() => {
          setOpenAlert(false);
          debounce(submitCancelRequest());
        }}
      />
    </Modal>
  );
}

export default AppointmentCancelRequestModal;
